import React, { useState, useCallback } from 'react';
import moment from "moment";
import { useTranslation } from "react-i18next";
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';

import './CustomDateRangePicker.css';

export default function CustomDateRangePicker(props) {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleCallback = useCallback(
    (start, end) => {
      // Paneme aja täpselt keskpäevale (12:00:00)
      // Nii on meil ees ja taga 12 tundi puhvrit ja ajavööndid ei saa päeva muuta!
      const s = moment(start).set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
      const e = moment(end).set({ hour: 12, minute: 0, second: 0, millisecond: 0 });

      setStartDate(s);
      setEndDate(e);

      props.setStartAndEndDate(s.toDate(), e.toDate());

      if (props.onDateRangeChange) {
        props.onDateRangeChange(s.toDate(), e.toDate());
      }
    },
    [props]
  );

  return (
    <>
      <div className="row">
        <div className={"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"}>
          <div className="card crm-data-card">
            <div className="text-right"></div>
            <div className="card-body animated fadeIn fast">
              <div className="row text-center d-flex align-items-center justify-content-between">

                {/* --- DATE PICKER --- */}
                <div className={"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3 mb-md-0"}>
                  <DateRangePicker
                    initialSettings={{
                      autoApply: false,
                      alwaysShowCalendars: true,
                      // MUUDETUD: Kasutame stringe, mitte Date objekte!
                      startDate: startDate ? startDate.format('DD.MM.YYYY') : moment().format('DD.MM.YYYY'),
                      endDate: endDate ? endDate.format('DD.MM.YYYY') : moment().format('DD.MM.YYYY'),
                      locale: {
                        format: 'DD.MM.YYYY',
                        cancelLabel: t("Cancel"),
                        applyLabel: t("Apply"),
                      }
                    }}
                    onApply={(e, picker) => {
                      handleCallback(picker.startDate, picker.endDate);
                      if (props.selectedTimeMode !== 5) {
                        props.setSelectedTimeMode(5);
                      }
                    }}
                  >
                    <button
                      type="button"
                      className={`button-style choose-date-button ${props.selectedTimeMode === 5 ? 'selected' : 'btn-info'}`}
                    >
                      {t("Choose Date")}
                    </button>
                  </DateRangePicker>
                </div>

                {/* --- KIIRVALIKUD --- */}
                <div className="d-inline-block w-100 mt-2">

                  {/* Beginning of the year */}
                  {props.selectedTimeMode === 4 && <span className="button-style-clicked"> {t("Beginning of the year")} </span>}
                  {props.selectedTimeMode !== 4 && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setSelectedTimeMode(4);
                        let startDate = moment().startOf('year').toDate();
                        let endDate = moment().toDate();
                        props.setStartAndEndDate(startDate, endDate);
                      }}
                      className={`button-style ${props.selectedTimeMode === 4 ? 'selected' : ''}`}
                    >
                      <span> {t("Beginning of the year")} </span>
                    </a>
                  )}

                  {/* Last 3 months */}
                  {props.selectedTimeMode === 3 && <span className="button-style-clicked">{t("Last 3 months")}</span>}
                  {props.selectedTimeMode !== 3 && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setSelectedTimeMode(3);
                        let startDate = moment().subtract(3, 'month').startOf('month').toDate();
                        let endDate = moment().toDate();
                        props.setStartAndEndDate(startDate, endDate);
                      }}
                      className={`button-style ${props.selectedTimeMode === 3 ? 'selected' : ''}`}
                    >
                      <span> {t("Last 3 months")} </span>
                    </a>
                  )}

                  {/* This month */}
                  {props.selectedTimeMode === 2 && <span className="button-style-clicked"> {t("This month")} </span>}
                  {props.selectedTimeMode !== 2 && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setSelectedTimeMode(2);
                        let startDate = moment().startOf('month').toDate();
                        let endDate = moment().toDate();
                        props.setStartAndEndDate(startDate, endDate);
                      }}
                      className={`button-style ${props.selectedTimeMode === 2 ? 'selected' : ''}`}
                    >
                      <span> {t("This month")} </span>
                    </a>
                  )}

                  {/* Last week */}
                  {props.selectedTimeMode === 1 && <span className="button-style-clicked">{t("Last week")} </span>}
                  {props.selectedTimeMode !== 1 && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setSelectedTimeMode(1);
                        let startDate = moment().subtract(1, 'weeks').startOf('week').toDate();
                        let endDate = moment().subtract(1, 'weeks').endOf('week').toDate();
                        props.setStartAndEndDate(startDate, endDate);
                      }}
                      className={`button-style ${props.selectedTimeMode === 1 ? 'selected' : ''}`}
                    >
                      <span> {t("Last week")} </span>
                    </a>
                  )}

                  {/* Current week */}
                  {props.selectedTimeMode === 0 && <span className="button-style-clicked">{t("Current week")}</span>}
                  {props.selectedTimeMode !== 0 && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setSelectedTimeMode(0);
                        let startDate = moment().startOf('week').toDate();
                        let endDate = moment().toDate();
                        props.setStartAndEndDate(startDate, endDate);
                      }}
                      className={`button-style ${props.selectedTimeMode === 0 ? 'selected' : ''}`}
                    >
                      <span> {t("Current week")}</span>
                    </a>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}